import { apiClient, handleResponse, handleError } from '../helpers';
import { api } from '../constants';
import {
    createRequestCacheKey,
    fetchWithCache,
    invalidateRequestCache,
} from '../helpers/requestCache';

const AD_MESSAGE_TTL_MS = 5 * 60 * 1000;
const adMessageCacheKey = () => createRequestCacheKey('ad', 'message');

export const admessageService = {
    fetchAdMessage,
    submitAdmessage
};

function fetchAdMessage() {
    return fetchWithCache({
        key: adMessageCacheKey(),
        ttlMs: AD_MESSAGE_TTL_MS,
        loader: () => apiClient.get(api.admessage.fetchAdmessage)
            .then(handleResponse)
            .then(data => data),
    })
        .catch(error => handleError(error.response));
}

function submitAdmessage(payload) {
    return apiClient.post(api.admessage.submitAdmessage, payload)
        .then(handleResponse)
        .then(data => {
            invalidateRequestCache(adMessageCacheKey());
            return data;
        })
        .catch(error => handleError(error.response));
}
